import React, { useState, useEffect } from "react";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import { ChangeCursor } from "./MiscFunctions";
import axios from "axios";
import { Button, Grid } from "@mui/material";
import { SaveAlt } from "@mui/icons-material";
import { Select } from "antd";
import "./UserComponents.scss";

import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import Navbar from "../../hlthtek-admin-demo/components/Navbar";
import { toast } from "react-toastify";
import { CustomStyledButtonSolid } from "../../doctor-console/StyledComponents";
import {
  convertISTtoUTC,
  formatDateIST,
} from "../../doctor-console/Utils/UtilsFunctions";
// import { TableHead } from "@mui/material";

function TransactionRecords() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setError,
    getValues,
    setValue,
  } = useForm();
  const [userRole, setUserRole] = useState(sessionStorage.getItem("roleType"));
  const [displayExistingDetails, setDisplayExistingDetails] = useState(false);
  const [displayBillingExistingDetails, setDisplayBillingExistingDetails] =
    useState(false);
  const [transactionRecords, setTransactionRecords] = useState(false);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const sessionRoleType =
    sessionStorage.getItem("roleType") !== undefined &&
      sessionStorage.getItem("roleType") !== null
      ? sessionStorage.getItem("roleType")
      : "";

  const [clientOptions, setClientOptions] = useState([]);
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [selectedPartnerOptions, setSelectedPartnerOptions] = useState([]);
  const [selectedClientOptions, setSelectedClientOptions] = useState([]);
  const [selectedFacilityOptions, setSelectedFacilityOptions] = useState([]);
  const [clientName, setClientName] = useState([]);

  const handlePartnerSelectChange = (selectedValues) => {
    console.log("partner selected values", selectedValues);
    setSelectedPartnerOptions(selectedValues);
    fetchClient(selectedValues);
  };
  const handleClientSelectChange = (selectedValues) => {
    // console.log("client selected values",selectedValues);
    setSelectedClientOptions(selectedValues);
    handleFacilityFromClient(selectedValues);
  };
  const handleFacilitySelectChange = (selectedValues) => {
    // console.log("facility selected values", selectedValues);
    setSelectedFacilityOptions(selectedValues);
    // handleClientFromPartner(selectedValues);
  };
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  useEffect(() => {
    const roleType = sessionStorage.getItem("roleType");
    // if (roleType === "admin" || roleType === "partner admin") {
    //   axios
    //     .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_partners_list/`, {
    //       headers: headers,
    //     })
    //     .then((res) => {
    //       console.log(res.data);
    //       setPartnerOptions(res.data.partner_list);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       toast.error(err);
    //     });
    // }
    if (roleType == "partner admin") {
      let partner_id = sessionStorage.getItem("partner_id");
      setValue("partner_id", [partner_id]);
      handlePartnerSelectChange([partner_id]);
    } else if (roleType == "customer admin") {
      let client_name = sessionStorage.getItem("customer_name");
      setClientOptions([
        {
          client_name: client_name,
        },
      ]);
      setValue("client_name", [client_name]);
      handleClientSelectChange([client_name]);
    } else if (roleType == "facility admin") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
          headers: headers,
        })
        .then((res) => {
          setFacilityOptions([
            {
              facility_id: res.data.facility_id,
              facility_name: res.data.facility_name,
            },
          ]);
          setValue("facility_id", [res.data.facility_id]);
          handleFacilitySelectChange([res.data.facility_id]);
        })
        .catch((error) => {
          console.error("Error fetching user info:", error);
        });
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const navigate = (e) => {
    history.push(`/${e.target.id}`);
  };
  // Helper function to determine column size based on role type
  const getColSize = () => {
    if (sessionRoleType === "customer admin") {
      return 6;
    } else if (sessionRoleType === "facility admin") {
      return 12;
    }
    return 4;
  };

  const getTransactionRecords = (data, e) => {
    e.preventDefault();
    console.log(data);
    //ChangeCursor();
    if (Token()) {
      var post_data = {};
      post_data.type = "facility";
      // post_data.start_datetime =
      //   data.start_datetime + "T" + data.start_time + ":00.000";
      // post_data.end_datetime =
      //   data.end_datetime + "T" + data.end_time + ":00.000";
      // post_data.start_time = data.start_time;
      var startUtcDateTime = convertISTtoUTC(
        data.start_datetime + "T" + data.start_time + ":00.000"
      );
      var endUtcDateTime = convertISTtoUTC(
        data.end_datetime + "T" + data.end_time + ":00.000"
      );
      post_data.start_datetime = startUtcDateTime;
      post_data.end_datetime = endUtcDateTime;
      post_data.start_time = startUtcDateTime.split("T")[1].substring(0, 5);
      post_data.end_time = endUtcDateTime.split("T")[1].substring(0, 5);
      post_data.partner_id =
        data.partner_id === undefined || data.partner_id.length === 0
          ? undefined
          : data.partner_id;
      post_data.client_name =
        data.client_name.length === 0 ? undefined : data.client_name;
      // post_data.facility_name = data.facility_name;
      post_data.facility_id =
        data.facility_id.length === 0 ? undefined : data.facility_id;
      console.log(post_data);
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_transaction_details/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status !== "Failed") {
            console.log("Transaction Data", res.data);
            setTransactionRecords(res.data);
            // console.log("data", data);
            if (data.recordType === "transaction") {
              setDisplayExistingDetails(true);
              setDisplayBillingExistingDetails(false);
            } else {
              setDisplayExistingDetails(false);
              setDisplayBillingExistingDetails(true);
            }
          } else {
            toast.success(res.data.message);
          }
          //ChangeCursor();
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          //ChangeCursor();
        });
    }
  };
  const getRowClassName = (params) => {
    return "custom-row";
  };
  const columns = [
    { field: "id", headerName: "Sl. No." },
    { field: "endpoint", headerName: "Service Name", width: 250 },
    { field: "username", headerName: "Username", width: 150 },
    { field: "ip_address", headerName: "IP Address", width: 150 },
    { field: "facility", headerName: "Facility", width: 150 },
    { field: "partner", headerName: "Partner", width: 150 },
    { field: "client", headerName: "Customer", width: 150 },
    { field: "subscription", headerName: "Subscription", width: 110 },
    { field: "transaction_mode", headerName: "Transaction Mode", width: 130 },
    { field: "time", headerName: "Time", width: 230 },
  ];
  const billing_columns = [
    { field: "id", headerName: "Sl. No." },
    // { field: "endpoint", headerName: "End Point", width: 250 },
    { field: "partner", headerName: "Partner", width: 150 },
    { field: "client", headerName: "Customer", width: 150 },
    { field: "facility", headerName: "Facility Name", width: 170 },
    {
      field: "facility_subscription",
      headerName: "Facility Subscription",
      width: 170,
    },
    { field: "hip_count", headerName: "HIP Count", width: 100 },
    { field: "hiu_count", headerName: "HIU Count", width: 100 },
    { field: "hmis_count", headerName: "HMIS Count", width: 150 },

    { field: "trial", headerName: "Trial Period", width: 100 },
    { field: "discount_percentage", headerName: "Discount(%)", width: 100 },

    { field: "total", headerName: "Total Billed Amount(INR)", width: 180 },
    { field: "net_total", headerName: "Net Payable(INR)", width: 150 },
  ];

  const rows = transactionRecords
    ? transactionRecords.transaction_details.map((item, index) => {
      // console.log("Transaction Item", item, index);

      // let endpoint = item.transaction_endpoint ?? "-";
      // let transaction_mode = item.transaction_mode ?? "-";

      // if (
      //   transaction_mode &&
      //   transaction_mode.toLowerCase() !== "hip" &&
      //   transaction_mode.toLowerCase() !== "hiu"
      // ) {
      //   const modeParts = transaction_mode.split(" (");
      //   endpoint = modeParts[0];
      //   console.log(modeParts[1]);
      //   transaction_mode = modeParts[1] ? modeParts[1].slice(0, -1) : "-"; // Remove trailing ')'
      // }

      return {
        id: index + 1,
        endpoint:
          item.transaction_group !== ""
            ? item.transaction_group
            : item.transaction_endpoint,
        partner: item.partner ?? "-",
        client: item.client ?? "-",
        facility: item.facility ?? "-",
        subscription: item.subscription ?? "-",
        transaction_mode: item.transaction_mode
          ? item.transaction_mode.toUpperCase()
          : "-",
        time: item.timestamp ? formatDateIST(item.timestamp) : "-",
        username: item.username !== null ? item.username : "-",
        ip_address: item.ip_address !== null ? item.ip_address : "-",
      };
    })
    : [];

  // Now `rows` contains the transformed transaction details.

  const billing_rows = transactionRecords
    ? transactionRecords.billing_details.map((item, index) => ({
      id: index + 1,
      // endpoint: item.transaction_endpoint,
      partner: item.partner_name,
      client: item.client_name,
      facility: item.facility_name,
      facility_subscription: item.facility_subscription,
      hip_count: item.hip_count,
      hiu_count: item.hiu_count,
      hmis_count: item.hmis_count,
      trial: item.trial ? "Yes" : "No",
      discount_percentage: item.discount_percentage,
      total: 5 * item.hip_count + 10 * item.hiu_count,
      net_total:
        5 * item.hip_count +
        10 * item.hiu_count -
        ((5 * item.hip_count + 10 * item.hiu_count) *
          item.discount_percentage) /
        100.0,
      // subscription: item.subscription,
      // transaction_mode:
      //   item.transaction_mode.charAt(0).toUpperCase() +
      //   item.transaction_mode.slice(1).toLowerCase(),
      // time: new Date(item.timestamp).toUTCString(),
    }))
    : [];

  const fetchClient = async () => {
    const roleType = sessionStorage.getItem("roleType");

    if (roleType === "admin" && Token()) {
      try {
        const res = await axios.get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_all_clients/`,
          {
            headers: headers,
          }
        );
        const clientName = res?.data?.client_list?.[0]?.client_name;
        console.log("In client func", clientName);
        setClientName(clientName);
        return clientName;
      } catch (err) {
        console.log(err);
        return null;
      }
    } else {
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const clientName = await fetchClient();
        console.log("clientName-", clientName);
        if (clientName) {
          console.log("clientName1-", clientName);
          handleFacilityFromClient(clientName);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Filter out selected clients that are not in the current clientOptions
    if (selectedPartnerOptions.length !== 0) {
      const validSelectedClients = selectedClientOptions.filter(
        (selectedClient) => {
          return clientOptions.some(
            (client) => client.client_name === selectedClient
          );
        }
      );

      if (validSelectedClients.length != selectedClientOptions.length) {
        handleClientSelectChange(validSelectedClients);
      }
      // console.log("valid selected clients", validSelectedClients);
      if (validSelectedClients.length === 0) {
        setSelectedFacilityOptions([]);
        setValue("facility_id", []);
      }
      setValue("client_name", validSelectedClients);
    } else {
      setSelectedFacilityOptions([]);
      setSelectedClientOptions([]);
      if (sessionRoleType !== "customer admin") setValue("client_name", []);
      setValue("facility_id", []);
    }
  }, [selectedPartnerOptions, clientOptions, setValue]);

  useEffect(() => {
    if (sessionRoleType != "facility admin") {
      const validSelectedFacilities = selectedFacilityOptions.filter(
        (selectedFacilty) => {
          return facilityOptions.some(
            (facility) => facility.facility_id === selectedFacilty
          );
        }
      );
      console.log("valid selected facilitiess", validSelectedFacilities);
      setSelectedFacilityOptions(validSelectedFacilities);
      setValue("facility_id", validSelectedFacilities);
    }
  }, [selectedClientOptions, facilityOptions, setValue]);

  const handleFacilityFromClient = (client_name) => {
    console.log("In facility func", client_name);
    if (client_name.length !== 0) {
      if (
        (sessionStorage.getItem("roleType") === "admin" ||
          sessionStorage.getItem("roleType") === "partner admin" ||
          sessionStorage.getItem("roleType") === "customer admin" ||
          sessionStorage.getItem("roleType") === "facility admin") &&
        Token()
      ) {
        var clientObj = { client_name: client_name };
        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}get_all_facility_list_from_client/`,
            clientObj,
            {
              headers: headers,
            }
          )
          .then((res) => {
            console.log("In facility func", res.data.facility_list);
            if (res.data.status === "Success") {
              setFacilityOptions(res.data.facility_list);
            } else {
              console.log(res?.data?.message);
              setFacilityOptions([]);
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
          });
      }
    }
  };

  const generatePdf = (recordType) => {
    const doc = new jsPDF();
    let tableHeaders, tableData;
    if (recordType === "transaction") {
      tableHeaders = columns.map((column) => column.headerName);
      tableData = rows.map((row) => columns.map((column) => row[column.field]));
    } else {
      tableHeaders = billing_columns.map((column) => column.headerName);
      tableData = billing_rows.map((row) =>
        billing_columns.map((column) => row[column.field])
      );
    }

    doc.setFontSize(12);
    if (recordType === "transaction") {
      doc.text("Transaction Records", 10, 10);
    } else {
      doc.text("Billing Records", 10, 10);
    }

    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 20,
      styles: { fontSize: 10, textColor: [0, 0, 0] },
    });
    if (recordType === "transaction") {
      doc.save("transaction_records.pdf");
    } else {
      doc.save("billing_records.pdf");
    }
  };
  const generateCsvData = (recordType) => {
    const headers = columns.map((column) => column.headerName);
    const csvData = [
      headers,
      ...rows.map((row) => columns.map((column) => row[column.field])),
    ];
    return csvData;
  };
  useEffect(() => {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`; // Format for input value (yyyy-mm-dd)
    };

    setValue("start_datetime", formatDate(firstDayOfMonth));
    setValue("end_datetime", formatDate(lastDayOfMonth));
  }, []);

  const renderCardsBasedOnRole = () => {
    if (userRole === "admin") {
      return (
        <>
          <Container>
            <Row
              style={{
                marginTop: "2%",
                marginbottom: "2%",
                paddingBottom: "2%",
                width: "125%",
                marginLeft: "-10%",
              }}
            >
              <Col>
                <Card
                  onClick={(e) => navigate(e)}
                  id="register_patient"
                  style={{
                    width: "100%",
                    marginLeft: "-30%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ display: "flex" }} id="register_patient">
                    <img
                      id="register_patient"
                      src="/img/success-black-check-mark.svg"
                      alt=""
                    />
                    <h6
                      id="register_patient"
                      style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                    >
                      Register Patient
                    </h6>
                  </div>
                </Card>
              </Col>
              <Col>
                <Card
                  onClick={(e) => navigate(e)}
                  id="care_context"
                  style={{
                    width: "140%",
                    marginLeft: "-35%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ display: "flex" }} id="care_context">
                    <img
                      src="/img/success-black-check-mark.svg"
                      id="care_context"
                      alt=""
                    />
                    <h6
                      id="care_context"
                      style={{ paddingTop: "8%", whiteSpace: "nowrap" }}
                    >
                      Create & Link Visit Purpose
                    </h6>
                  </div>
                </Card>
              </Col>
              {sessionStorage.getItem("subscriptionType") !== undefined &&
                sessionStorage.getItem("subscription_type") !== null &&
                sessionStorage
                  .getItem("subscription_type")
                  .includes("Connector/Adaptor") ? (
                []
              ) : (
                <Col>
                  <Card
                    onClick={(e) => navigate(e)}
                    id="upload_report"
                    style={{ width: "100%", height: "100%", cursor: "pointer" }}
                  >
                    <div style={{ display: "flex" }} id="upload_report">
                      <img
                        id="upload_report"
                        src="/img/success-black-check-mark.svg"
                        alt=""
                      />
                      <h6
                        id="upload_report"
                        style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                      >
                        Upload Report
                      </h6>
                    </div>
                  </Card>
                </Col>
              )}
              <Col>
                <Card
                  onClick={(e) => navigate(e)}
                  id="consent"
                  style={{ width: "100%", height: "100%", cursor: "pointer" }}
                >
                  <div style={{ display: "flex" }} id="consent">
                    <img
                      id="consent"
                      src="/img/success-black-check-mark.svg"
                      alt=""
                    />
                    <h6
                      id="consent"
                      style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                    >
                      EHR Data Access
                    </h6>
                  </div>
                </Card>
              </Col>
              <Col>
                <Card
                  onClick={(e) => navigate(e)}
                  id="admin_services"
                  style={{ width: "100%", height: "100%", cursor: "pointer" }}
                >
                  <div style={{ display: "flex" }} id="admin_services">
                    <img
                      id="admin_services"
                      src="/img/success-black-check-mark.svg"
                      alt=""
                    />
                    <h6
                      id="admin_services"
                      style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                    >
                      Admin Services
                    </h6>
                  </div>
                </Card>
              </Col>
              <Col>
                <Card
                  onClick={(e) => navigate(e)}
                  id="scan_qr"
                  style={{ width: "100%", height: "100%", cursor: "pointer" }}
                >
                  <div style={{ display: "flex" }} id="scan_qr">
                    <img
                      id="scan_qr"
                      src="/img/success-black-check-mark.svg"
                      alt=""
                    />
                    <h6
                      id="scan_qr"
                      style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                    >
                      QR
                    </h6>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      );
    }

    return null;
  };

  // console.log(partnerOptions);
  return (
    <>
      {/* <Navbar /> */}
      {/* <h3 style={{ textAlign: "left", width: "100%" }}>
        Get Transaction Records
      </h3> */}
      {userRole === "user" ||
        (userRole === "facility user" && (
          <Container>
            <Row
              style={{
                marginTop: "2%",
                marginbottom: "2%",
                paddingBottom: "2%",
                width: "100%",
              }}
            >
              {renderCardsBasedOnRole()}
            </Row>
          </Container>
        ))}

      {/* <div style={{ width: '60vw' }} > */}
      <div className="contact-panel mb-50 m-auto" style={{ width: "80vw", height: "55vh", marginTop: "20px", marginBottom: "20px", marginRight: "5px", marginLeft: "5px", padding: "40px" }}>
        <h5 style={{ textAlign: "center", width: "100%" }}>
          Get Transaction Records
        </h5>
        <form
          className="contact-panel__form"
          onSubmit={handleSubmit(getTransactionRecords)}
        >
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <label>Start Date</label>
              <div className="form-group form-group-date">
                <i className="icon-calendar form-group-icon"></i>
                <input
                  type="date"
                  className="form-control"
                  name="start_datetime"
                  {...register("start_datetime", {
                    required: "Start Date is required.",
                  })}
                />
                {errors.start_date && (
                  <p className="errorMsg">{errors.start_date.message}</p>
                )}
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <label>Start Time</label>
              <div className="form-group form-group-date">
                <i className="icon-calendar form-group-icon"></i>
                <input
                  type="time"
                  className="form-control"
                  name="start_time"
                  defaultValue="00:00"
                  {...register("start_time")}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <label>End Date</label>
              <div className="form-group form-group-date">
                <i className="icon-calendar form-group-icon"></i>
                <input
                  type="date"
                  className="form-control"
                  placeholder="Enter End Date"
                  name="end_datetime"
                  {...register("end_datetime", {
                    required: "End Date is required.",
                  })}
                />
                {errors.end_date && (
                  <p className="errorMsg">{errors.end_date.message}</p>
                )}
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <label>End Time</label>
              <div className="form-group form-group-date">
                <i className="icon-calendar form-group-icon"></i>
                <input
                  type="time"
                  className="form-control"
                  name="end_time"
                  defaultValue="23:59"
                  {...register("end_time")}
                />
              </div>
            </div>
          </div>
          <input
            type="hidden"
            name="recordType"
            {...register("recordType")} // Assuming you're using react-hook-form
          />

          <div className="row">
            {sessionRoleType !== "facility admin" && (
              <div className="col-sm-12 col-md-6 col-lg-6">
                <label>Customer</label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    value={clientName}
                    disabled
                  />
                </div>
              </div>
            )}

            <div className="col-sm-12 col-md-6 col-lg-6">
              <label>Select Facility</label>
              <div className="form-group">
                <Controller
                  name="facility_id"
                  control={control}
                  render={({ field }) => (
                    <Select
                      mode="multiple"
                      placeholder="Select Facility"
                      className="custom-select-matching-time"
                      style={{ width: "100%" }}
                      dropdownStyle={{ boxShadow: "none" }}
                      onChange={(selectedValues) => {
                        field.onChange(selectedValues);
                        handleFacilitySelectChange(selectedValues);
                      }}
                      value={field.value}
                      disabled={sessionRoleType === "facility admin"}
                      options={facilityOptions.map((f) => ({
                        label: f.facility_name,
                        value: f.facility_id,
                      }))}
                    />
                  )}
                />
                {errors.facility_name && (
                  <p className="errorMsg">{errors.facility_name.message}</p>
                )}
              </div>
            </div>
          </div>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <button
                fullWidth
                type="submit"
                className="btn btn__secondary btn__rounded btn__block mt-2"
                name="recordType"
                value="transaction"
                onClick={() => {
                  setValue("recordType", "transaction"); // Set the value of the hidden input
                }}
                sx={{ width: "100%", borderRadius: "10px", background: "#0E3F66" }}
              >
                Get Transaction Records
                <span>
                  <i
                    className="icon-arrow-right"
                    style={{ margin: "10px" }}
                  ></i>
                </span>
              </button>
            </Grid>
            <Grid item xs={12} md={6}>
              <button
                fullWidth
                type="submit"
                className="btn btn__secondary btn__rounded btn__block mt-2"
                name="recordType"
                value="billing"
                onClick={() => {
                  setValue("recordType", "billing"); // Set the value of the hidden input
                }}
                sx={{ width: "100%", borderRadius: "10px", background: "#0E3F66" }}
              >
                Get Billing Records
                <span>
                  <i
                    className="icon-arrow-right"
                    style={{ margin: "10px" }}
                  ></i>
                </span>
              </button>
            </Grid>
          </Grid>

          {/* <input type="hidden" name="recordType" ref={register} /> */}
          <div className="contact-result"></div>
        </form>
      </div>
      {/* </div> */}
      {displayExistingDetails ? (
        <div style={{ paddingTop: "3%" }}>
          {/* <div style={{ margin: "AUTO", maxWidth: "1200px" }}>
            <label>Total Transactions</label>
            <div className="form-group">
              <i className="icon-news form-group-icon"></i>
              <input
                type="text"
                className="form-control"
                value={
                  transactionRecords !== undefined
                    ? transactionRecords.total_transactions
                    : ""
                }
                placeholder="Total Transactions"
                name="total_transactions"
                readOnly
              />
            </div>
          </div> */}
          <div className="contact-panel mb-5 m-auto"
            style={{
              width: "60vw",
              display: "flex",
              flexDirection: "row",
              padding: "30px",
            }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#000",
                }}
              >
                Total Transactions:
              </span>
              {/* <div className="form-group" style={{ display: 'flex', alignItems: 'center', width: '200px' }}> */}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                {
                  transactionRecords !== undefined
                    ? transactionRecords.total_transactions
                    : "0"
                }
              </span>
              {/* <i className="icon-news form-group-icon"></i>
                <input
                  type="text"
                  className="form-control"
                  value={
                    transactionRecords !== undefined
                      ? transactionRecords.total_transactions
                      : ""
                  }
                  placeholder="Total Transactions"
                  name="total_transactions"
                  readOnly
                  style={{ width: '100%' }}
                /> */}
              {/* </div> */}
            </div>
          </div>



          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "auto",
              width: "100%",
              maxWidth: "1200px", // Set a max width for large screens
              padding: "1rem",
            }}
          >

            <div style={{ width: "100%" }}>
              <h5 style={{ textAlign: "center" }}>Transaction List</h5>
              <div className="display-flex">
                <DataGrid
                  rows={rows}
                  columns={columns}
                  components={{
                    Toolbar: () => (
                      <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          mb: 2,
                        }}
                      >
                        {/* Left Section - Toolbar Buttons */}
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={8}
                          sx={{ display: "flex", gap: 1 }}
                        >
                          <GridToolbarColumnsButton />
                          <GridToolbarFilterButton />
                          <GridToolbarDensitySelector />
                        </Grid>

                        {/* Right Section - Download Buttons */}
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          sx={{
                            display: "flex",
                            gap: 1,
                            justifyContent: { xs: "center", sm: "flex-end" },
                          }}
                        >
                          <Button
                            variant="text"
                            color="primary"
                            onClick={() => generatePdf("transaction")}
                            startIcon={<SaveAlt />}
                          >
                            Download PDF
                          </Button>
                          <CSVLink
                            data={generateCsvData("transaction")}
                            filename={"transaction_records.csv"}
                            target="_blank"
                          >
                            <Button
                              variant="text"
                              color="primary"
                              startIcon={<SaveAlt />}
                            >
                              Download CSV
                            </Button>
                          </CSVLink>
                        </Grid>
                      </Grid>
                    ),
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 10 },
                    },
                  }}
                  pageSizeOptions={[5, 10]}
                  getRowClassName={getRowClassName}
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      fontFamily: "Arial, sans-serif",
                      padding: "5px"
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#125386",
                      color: "white",
                      fontSize: "13px",
                      fontWeight: "600",
                      minHeight: "48px !important",
                      "& .MuiDataGrid-columnHeaderTitle": {
                        color: "white",
                        fontWeight: "600",
                        fontSize: "13px",
                      },
                      "& .MuiDataGrid-columnHeader": {
                        borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                        padding: "0 12px",
                      },
                      "& .MuiDataGrid-columnHeader:last-child": {
                        borderRight: "none",
                      },
                      "& .MuiDataGrid-iconButtonContainer": {
                        color: "white",
                      },
                      "& .MuiDataGrid-menuIcon": {
                        color: "white",
                      },
                      "& .MuiDataGrid-sortIcon": {
                        color: "white",
                      },
                      "& .MuiDataGrid-columnHeaderSortable": {
                        "& .MuiDataGrid-sortIcon": {
                          color: "white",
                        },
                      },
                      "& .MuiDataGrid-columnHeaderTitleContainer": {
                        "& .MuiDataGrid-sortIcon": {
                          color: "white",
                        },
                      },
                      "& .MuiSvgIcon-root": {
                        color: "white",
                      },
                    },
                    "& .MuiDataGrid-row": {
                      backgroundColor: "white",
                      minHeight: "40px !important",
                      "&:nth-of-type(even)": {
                        backgroundColor: "white",
                      },
                      "&:hover": {
                        backgroundColor: "#f8f9fa",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#e3f2fd",
                        "&:hover": {
                          backgroundColor: "#e3f2fd",
                        },
                      },
                      borderBottom: "1px solid #e0e0e0",
                    },
                    "& .MuiDataGrid-cell": {
                      borderRight: "1px solid #e0e0e0",
                      fontSize: "12px",
                      color: "#374151",
                      padding: "8px 12px",
                      minHeight: "40px !important",
                      "&:last-child": {
                        borderRight: "none",
                      },
                      "&:focus": {
                        outline: "none",
                      },
                    },
                    "& .MuiDataGrid-cellContent": {
                      fontSize: "12px",
                      color: "#374151",
                      fontWeight: "400",
                    },
                    "& .MuiDataGrid-footerContainer": {
                      backgroundColor: "#f8f9fa",
                      borderTop: "1px solid #e0e0e0",
                      minHeight: "52px",
                    },
                    "& .MuiTablePagination-root": {
                      color: "#374151",
                      fontSize: "12px",
                    },
                    "& .MuiDataGrid-toolbarContainer": {
                      backgroundColor: "#f8f9fa",
                      borderBottom: "1px solid #e0e0e0",
                      padding: "8px 16px",
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        []
      )}
      {displayBillingExistingDetails ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "auto",
            width: "100%",
            maxWidth: "1200px", // Set a max width for large screens
            padding: "1rem",
          }}
        >

          <div style={{ width: "100%" }}>
            <h4 style={{ textAlign: "center" }}>Billing List</h4>
            <div className="display-flex">
              {" "}
              <DataGrid
                rows={billing_rows}
                columns={billing_columns}
                components={{
                  Toolbar: () => (
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        mb: 2,
                      }}
                    >
                      {/* Left Section - Toolbar Buttons */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={8}
                        sx={{ display: "flex", gap: 1 }}
                      >
                        <GridToolbarColumnsButton />
                        <GridToolbarFilterButton />
                        <GridToolbarDensitySelector />
                      </Grid>

                      {/* Right Section - Download Buttons */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        sx={{
                          display: "flex",
                          gap: 1,
                          justifyContent: { xs: "center", sm: "flex-end" },
                        }}
                      >
                        <Button
                          variant="text"
                          color="primary"
                          onClick={() => generatePdf("transaction")}
                          startIcon={<SaveAlt />}
                        >
                          Download PDF
                        </Button>
                        <CSVLink
                          data={generateCsvData("transaction")}
                          filename={"transaction_records.csv"}
                          target="_blank"
                        >
                          <Button
                            variant="text"
                            color="primary"
                            startIcon={<SaveAlt />}
                          >
                            Download CSV
                          </Button>
                        </CSVLink>
                      </Grid>
                    </Grid>
                  ),
                }}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                }}
                pageSizeOptions={[5, 10]}
                getRowClassName={getRowClassName}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "1px solid #e0e0e0",
                    borderRadius: "4px",
                    fontFamily: "Arial, sans-serif",
                    padding: "5px"
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#125386",
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "600",
                    minHeight: "48px !important",
                    "& .MuiDataGrid-columnHeaderTitle": {
                      color: "white",
                      fontWeight: "600",
                      fontSize: "13px",
                    },
                    "& .MuiDataGrid-columnHeader": {
                      borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                      padding: "0 12px",
                    },
                    "& .MuiDataGrid-columnHeader:last-child": {
                      borderRight: "none",
                    },
                    "& .MuiDataGrid-iconButtonContainer": {
                      color: "white",
                    },
                    "& .MuiDataGrid-menuIcon": {
                      color: "white",
                    },
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                    "& .MuiDataGrid-columnHeaderSortable": {
                      "& .MuiDataGrid-sortIcon": {
                        color: "white",
                      },
                    },
                    "& .MuiDataGrid-columnHeaderTitleContainer": {
                      "& .MuiDataGrid-sortIcon": {
                        color: "white",
                      },
                    },
                    "& .MuiSvgIcon-root": {
                      color: "white",
                    },
                  },
                  "& .MuiDataGrid-row": {
                    backgroundColor: "white",
                    minHeight: "40px !important",
                    "&:nth-of-type(even)": {
                      backgroundColor: "white",
                    },
                    "&:hover": {
                      backgroundColor: "#f8f9fa",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#e3f2fd",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                      },
                    },
                    borderBottom: "1px solid #e0e0e0",
                  },
                  "& .MuiDataGrid-cell": {
                    borderRight: "1px solid #e0e0e0",
                    fontSize: "12px",
                    color: "#374151",
                    padding: "8px 12px",
                    minHeight: "40px !important",
                    "&:last-child": {
                      borderRight: "none",
                    },
                    "&:focus": {
                      outline: "none",
                    },
                  },
                  "& .MuiDataGrid-cellContent": {
                    fontSize: "12px",
                    color: "#374151",
                    fontWeight: "400",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    backgroundColor: "#f8f9fa",
                    borderTop: "1px solid #e0e0e0",
                    minHeight: "52px",
                  },
                  "& .MuiTablePagination-root": {
                    color: "#374151",
                    fontSize: "12px",
                  },
                  "& .MuiDataGrid-toolbarContainer": {
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e0e0e0",
                    padding: "8px 16px",
                  },
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        []
      )}
    </>
  );
}

export default TransactionRecords;
